import gql from 'graphql-tag';

const FRAGMENT = gql`
  fragment ConferenceNote on conference_notes {
    id
    created_at
    text
    user {
        ...UserSummary
    }
    conference_id
  }
  fragment UserSummary on users {
    user_id
    user_first_name
    user_last_name
    user_pic
  }
`;

export const GET_CONFERENCE_NOTES = gql`
  query getConferenceNotes($conferenceId: Int!) {
    conferenceNotes: conference_notes(
      where: { conference_id: { _eq: $conferenceId } }
      order_by: { created_at: asc }
    ) {
      ...ConferenceNote
    }
  }
  ${FRAGMENT}
`;

export const ADD_CONFERENCE_NOTE = gql`
  mutation addConferenceNote($data: conference_notes_insert_input!) {
    row: insert_conference_notes_one(object: $data) {
      ...ConferenceNote
    }
  }
  ${FRAGMENT}
`;
